import React from 'react'
import {useField} from "formik";
import styles from './Checkbox.module.scss';
import { useTranslation } from "react-i18next";
import {HelpText} from "../HelpText/HelpText";

export const Checkbox = ({label, required, helpText, ...props }) => {
    const { t } = useTranslation();
    const [field, meta] = useField({ ...props, type: 'checkbox' });

    return (
        <div className={styles.checkboxContainer}>
            <div className={styles.checkboxInputContainer}>
                <input
                    {...field}
                    {...props}
                    id={props.id || props.name}
                    className={styles.checkboxInput}
                    type="checkbox"
                />

                {label &&
                    <label htmlFor={props.id || props.name} className={styles.checkboxLabel}>
                        {label}

                        {required && <span className={styles.required}>*</span>}
                    </label>
                }
            </div>

            {helpText &&
                <HelpText>{helpText}</HelpText>
            }

            {(meta.touched && meta.error) &&
                <div className={styles.error}>{t('input_component.is_required')}</div>
            }
        </div>
    );
};
